import React, { useMemo } from 'react';
import PriceModel from '../../../Types/PriceModel';
import { translate } from '../../../Services/translation';
interface TieredPricesPanelProps {
  priceModel: PriceModel;
  packageSize?: number;
}

interface TierPriceViewInterface {
  formattedPrice: string;
  savings?: string;
  amountMessage: string;
}
const IsSingleUnit = (packageSize, minimumQuantity) => {
  if (!packageSize || packageSize === 1 || packageSize > minimumQuantity)
    return true;
  else return false;
};
const IsBulkUnit = (packageSize, minimumQuantity) => {
  if (packageSize <= minimumQuantity) return true;
  else return false;
};

const TieredPricesPanel = ({
  priceModel,
  packageSize,
}: TieredPricesPanelProps) => {
  const getTierPriceMessage = (
    minimumQuantity: number,
    packageSize: number | undefined,
    unit?: string
  ) => {
    if (IsSingleUnit(packageSize, minimumQuantity))
      return `${translate('tire-price-message.single-units')}`;
    else if (IsBulkUnit(packageSize, minimumQuantity))
      return `${translate(
        'tire-price-message.bulk-units'
      )} ${packageSize} ${unit}`;
    else {
      console.error('Cant get tiered price message');
      return '';
    }
  };

  const getAmountSaved = (tierPrice: number, basePrice: number) => {
    if (tierPrice < basePrice) {
      return `${100 - Math.floor((tierPrice / basePrice) * 100)} %`;
    } else return '';
  };

  const getFormattedPrice = (price: number, currency: string) => {
    return `${price} ${currency}`;
  };

  const tieredPrices = useMemo(() => {
    if (!priceModel.price && !priceModel?.tierPrices) return '';
    let localTieredPrices = [] as TierPriceViewInterface[];
    priceModel.tierPrices.forEach((obj) => {
      const tierPrice = {
        formattedPrice: getFormattedPrice(
          obj.price,
          priceModel.currency.id
        ),
        savings: getAmountSaved(obj.price, priceModel.price.price),
        amountMessage: getTierPriceMessage(
          obj.minimumQuantity,
          packageSize,
          priceModel.price?.unitOfMeasurementTitle
        ),
      };
      localTieredPrices.push(tierPrice);
    });
    return localTieredPrices;
  }, []);

  return (
    <div>
      {tieredPrices && tieredPrices.length > 0 && (
        <div className="flex flex-col gap-3">
          <div>
            <div className="mb-3 text-lg font-bold">
              {translate('detailed-product-card.tier-prices-title')}
            </div>
            <div className="text-md">
              {translate('detailed-product-card.tier-prices-info')}
            </div>
          </div>
          <div className="grid grid-cols-[1fr_2fr_1fr] text-md font-bold">
            <span>{translate('product-card.price-per-unit')}</span>
            <span>{translate('product-card.you-save')}</span>
            <span>{translate('product-card.amount')}</span>
          </div>
          {tieredPrices.map((tierPrice, idx) => (
            <div
              key={idx}
              className="grid grid-cols-[1fr_2fr_1fr] text-md"
            >
              <span> {tierPrice.formattedPrice}</span>
              <span> {tierPrice.savings}</span>
              <span> {tierPrice.amountMessage}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TieredPricesPanel;
